export function formatProbabilityPercent(probability?: number): string | null {
  if (!probability) {
    return null;
  }
  return `${Math.round(probability * 100)}%`;
}
